var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expand-icon__wrapper pb-3"},[_c('v-icon',{staticClass:"expand-icon",attrs:{"small":""},on:{"click":_vm.showExpandedDialog}},[_vm._v(" mdi-arrow-expand ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }